export const questionsData = {
  age: {
    options: {
      puppy: {
        value: 'puppy',
      },
      adult: {
        value: 'adult',
      },
    },
  },
  role: {
    options: {
      puppy: {
        value: 'puppy',
        description: 'puppy_description',
        role: 'haveDog',
      },
      dog: {
        value: 'dog',
        description: 'dog_description',
        role: 'haveDog',
      },
      wannabe: {
        value: 'wannabe',
        description: 'wannabe_description',
        role: 'wannabe',
      },
    },
  },
  puppy_or_adult: {
    options: {
      puppy: {
        value: 'puppy',
      },
      adult: {
        value: 'adult',
      },
      skip: {
        value: 'skip',
      },
    },
  },
  how_old: {
    options: {
      zero: {
        value: 'zero',
      },
      six: {
        value: 'six',
      },
      year: {
        value: 'year',
      },
      two_years: {
        value: 'two_years',
      },
      five_years: {
        value: 'five_years',
      },
      dont_know: {
        value: 'dont_know',
      },
      skip: {
        value: 'skip',
      },
    },
  },
  breed: {
    options: {
      labrador_retriever: {
        value: 'labrador_retriever',
      },
      french_bulldog: {
        value: 'french_bulldog',
      },
      golden_retriever: {
        value: 'golden_retriever',
      },
      german_shepherd: {
        value: 'german_shepherd',
      },
      poodle: {
        value: 'poodle',
      },
      mixed_breed: {
        value: 'mixed_breed',
      },
      dont_know: {
        value: 'dont_know',
      },
      skip: {
        value: 'skip',
      },
    },
  },
  dog_name: {
    options: {
      skip: {
        value: 'skip',
      },
    },
  },
  goal: {
    options: {
      teaching_obedience: {
        age: 'adult',
        value: 'teaching_obedience',
      },
      correcting_behavior: {
        age: 'adult',
        value: 'correcting_behavior',
      },
      getting_shape: {
        age: 'adult',
        value: 'getting_shape',
      },
      rasing_adopted_dog: {
        age: 'adult',
        value: 'rasing_adopted_dog',
      },
      playing_with_pooch: {
        age: 'adult',
        value: 'playing_with_pooch',
      },
      teaching_puppy: {
        age: 'puppy',
        value: 'teaching_puppy',
      },
      surviving_puppy: {
        age: 'puppy',
        value: 'surviving_puppy',
      },
      socializing_puppy: {
        age: 'puppy',
        value: 'socializing_puppy',
      },
      other: {
        value: 'other',
      },
    },
  },
  biting: {
    options: {
      yes: {
        value: 'yes',
      },
      sometimes: {
        value: 'sometimes',
      },
      no: {
        value: 'no',
      },
    },
  },
  potty_training: {
    options: {
      yes: {
        value: 'yes',
      },
      a_bit: {
        value: 'a_bit',
      },
      no: {
        value: 'no',
      },
    },
  },
  commands: {
    options: {
      sit: {
        value: 'sit',
      },
      wait: {
        value: 'wait',
      },
      stay: {
        value: 'stay',
      },
      place: {
        value: 'place',
      },
      down: {
        value: 'down',
      },
      leave_it: {
        value: 'leave_it',
      },
      come: {
        value: 'come',
      },
    },
  },
  commands_puppy: {
    options: {
      sit: {
        value: 'sit',
      },
      wait: {
        value: 'wait',
      },
      stay: {
        value: 'stay',
      },
      place: {
        value: 'place',
      },
      down: {
        value: 'down',
      },
      leave_it: {
        value: 'leave_it',
      },
      come: {
        value: 'come',
      },
    },
  },
  being_home_alone: {
    options: {
      yes: {
        value: 'yes',
      },
      short_period: {
        value: 'short_period',
      },
      no: {
        value: 'no',
      },
    },
  },
  being_home_alone_puppy: {
    options: {
      yes: {
        value: 'yes',
      },
      it_varies: {
        value: 'it_varies',
      },
      no: {
        value: 'no',
      },
    },
  },
  hygiene: {
    options: {
      yes: {
        value: 'yes',
      },
      only_with_some: {
        value: 'only_with_some',
      },
      no: {
        value: 'no',
      },
    },
  },
  chewing: {
    options: {
      yes: {
        value: 'yes',
      },
      sometimes: {
        value: 'sometimes',
      },
      no: {
        value: 'no',
      },
    },
  },
  jumping_on_people: {
    options: {
      yes: {
        value: 'yes',
      },
      sometimes: {
        value: 'sometimes',
      },
      no: {
        value: 'no',
      },
    },
  },
  being_for_food: {
    options: {
      yes: {
        value: 'no',
      },
      sometimes: {
        value: 'sometimes',
      },
      no: {
        value: 'yes',
      },
    },
  },
  obedience: {
    options: {
      no: {
        value: 'no',
      },
      sometimes: {
        value: 'fifty_fifty',
      },
      yes: {
        value: 'yes',
      },
    },
  },
  picking_up_from_the_ground: {
    options: {
      yes: {
        value: 'no',
      },
      sometimes: {
        value: 'sometimes',
      },
      no: {
        value: 'yes',
      },
    },
  },
  mail: {},

  // customV1
  customV1_gender: {
    options: {
      girl: {
        value: 'girl',
      },
      boy: {
        value: 'boy',
      },
    },
  },
  customV1_age: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
      three: {
        value: 'v3',
      },
      four: {
        value: 'v4',
      },
      five: {
        value: 'v5',
      },
    },
  },
  customV1_breed: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
      three: {
        value: 'v3',
      },
      four: {
        value: 'v4',
      },
      five: {
        value: 'v5',
      },
      six: {
        value: 'v6',
      },
      seven: {
        value: 'v7',
      },
      eight: {
        value: 'v8',
      },
    },
  },
  customV1_commands: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
      three: {
        value: 'v3',
      },
      four: {
        value: 'v4',
      },
      five: {
        value: 'v5',
      },
      six: {
        value: 'v6',
      },
      seven: {
        value: 'v7',
      },
      eight: {
        value: 'v8',
      },
      nine: {
        value: 'v9',
      },
      ten: {
        value: 'v10',
      },
    },
  },
  customV1_descriptionV1: {
    options: {
    },
  },
  customV1_nervous: {
    options: {
      one: {
        value: 'yes',
      },
      two: {
        value: 'soso',
      },
      three: {
        value: 'no',
      },
    },
  },
  customV1_anxious: {
    options: {
      one: {
        value: 'yes',
      },
      two: {
        value: 'soso',
      },
      three: {
        value: 'no',
      },
    },
  },
  customV1_stressed: {
    options: {
      one: {
        value: 'yes',
      },
      two: {
        value: 'soso',
      },
      three: {
        value: 'no',
      },
    },
  },
  customV1_being_home_alone: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
      three: {
        value: 'v3',
      },
      four: {
        value: 'v4',
      },
    },
  },
  customV1_walk: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
      three: {
        value: 'v3',
      },
    },
  },
  customV1_hygiene: {
    options: {
      one: {
        value: 'yes',
      },
      two: {
        value: 'soso',
      },
      three: {
        value: 'no',
      },
    },
  },
  customV1_concern: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
      three: {
        value: 'v3',
      },
      four: {
        value: 'v4',
      },
      five: {
        value: 'v5',
      },
      six: {
        value: 'v6',
      },
    },
  },
  customV1_dangerous_situation: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
    },
  },
  customV1_these_commands: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
    },
  },
  customV1_eat_something_bad: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
    },
  },
  customV1_this_command: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
    },
  },
  customV1_afraid: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
    },
  },
  customV1_descriptionV2: {
    options: {
    },
  },
  customV1_when_called: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
    },
  },
  customV1_when_chews: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
    },
  },
  customV1_boundaries: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
    },
  },
  customV1_hard_training: {
    options: {
      one: {
        value: 'yes',
      },
      two: {
        value: 'soso',
      },
      three: {
        value: 'no',
      },
    },
  },
  customV1_main_goal: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
      three: {
        value: 'v3',
      },
      four: {
        value: 'v4',
      },
    },
  },
  customV1_training_time: {
    options: {
      one: {
        value: 'v1',
      },
      two: {
        value: 'v2',
      },
      three: {
        value: 'v3',
      },
    },
  },
  customV1_loader: {},
  customV1_email: {},
  customV1_startPage: {},

  // customV2
  customV2_startPage: {

  },
  customV2_startPageV2: {

  },
  customV2_startPageV3: {

  },
  customV2_startPageV4: {

  },
  customV2_startPageV5: {

  },
  customV2_startPageV6: {

  },
  customV2_startPageV7: {

  },
  customV2_startPageV8: {

  },
  customV2_startPageV11: {

  },
  customV2_startPageV12: {

  },
  customV2_startPageV13: {

  },
  customV2_startPageV17: {

  },
  customV2_startPageV18: {

  },
  customV2_startPageV19: {

  },
  customV2_startPageV20: {

  },
  customV2_startPageV21: {

  },
  customV2_startPageV22: {

  },
  customV2_startPageV23: {

  },
  customV2_startPageV24: {

  },
  customV2_startPageV25: {

  },
  customV2_startPageV26: {

  },
  customV2_startPageV27: {

  },
  customV2_startPageV28: {

  },
  customV2_startPageV29: {

  },
  customV2_startPageV30: {

  },
  customV2_startPageV31: {

  },
  customV2_policyPage: {

  },

  customV2_policyPageV2: {

  },
  customV2_policyPageV3: {

  },
  customV2_policyPageV4: {

  },
  customV2_policyPageV5: {

  },
  customV2_videoPolicyPage: {

  },

  customV2_start_page_video: {

  },
  customV2_start_page_video_v2: {},
  customV2_gender: {
    options: {
      v1: {
        index: 'v1',
        value: 'Girl',
        a_value: 'girl',
      },
      v2: {
        index: 'v2',
        value: 'Boy',
        a_value: 'boy',
      },
    },
  },
  customV2_name: {

  },
  customV2_age: {
    options: {
      one: {
        index: 'v1',
        value: '0-6 months',
        a_value: '0-6m',
      },
      two: {
        index: 'v2',
        value: '7-12 months',
        a_value: '7-12m',
      },
      three: {
        index: 'v3',
        value: '1-2 years',
        a_value: '1-2y',
      },
      four: {
        index: 'v4',
        value: '2-7 years',
        a_value: '2-7y',
      },
      five: {
        index: 'v5',
        value: 'More than 7 years',
        a_value: 'more7y',
      },
    },
  },
  customV2_breed: {

  },
  customV2_health: {
    options: {
      one: {
        index: 'v1',
        value: 'My dog is healthy',
        a_value: 'healthy',
      },
      two: {
        index: 'v2',
        value: 'Vision',
        a_value: 'vision',
      },
      three: {
        index: 'v3',
        value: 'Hearing',
        a_value: 'hearing',
      },
      four: {
        index: 'v4',
        value: 'Joints',
        a_value: 'joints',
      },
      five: {
        index: 'v5',
        value: 'Dental',
        a_value: 'dental',
      },
    },
  },
  customV2_potty: {
    options: {
      one: {
        index: 'v1',
        value: 'No consistent potty routine',
        a_value: 'no_consistent_potty_routine',
      },
      two: {
        index: 'v2',
        value: 'Has trouble holding it overnight',
        a_value: 'trouble_overnight',
      },
      three: {
        index: 'v3',
        value: 'Accidents when home alone',
        a_value: 'when_home_alone',
      },
      four: {
        index: 'v4',
        value: 'All good, no issues!',
        a_value: 'all_good',
      },
    },
  },
  customV2_issues: {
    options: {
      one: {
        index: 'v1',
        value: 'Difficulties with crate training',
        a_value: 'crate_training',
      },
      two: {
        index: 'v2',
        value: 'Biting',
        a_value: 'biting',
      },
      three: {
        index: 'v3',
        value: 'Barking',
        a_value: 'barking',
      },
      four: {
        index: 'v4',
        value: 'Chewing or damaging furniture',
        a_value: 'chewing_damaging',
      },
      five: {
        index: 'v5',
        value: 'Very anxious and sad when left alone',
        a_value: 'anxious',
      },
    },
  },
  customV2_issues_2: {
    options: {
      one: {
        index: 'v1',
        value: 'Biting',
        a_value: 'biting_nipping',
      },
      two: {
        index: 'v2',
        value: 'Leash pulling',
        a_value: 'pulling_leash',
      },
      three: {
        index: 'v3',
        value: 'Chewing or damaging furniture',
        a_value: 'chewing_damaging',
      },
      four: {
        index: 'v4',
        value: 'Anxiety when left alone',
        a_value: 'anxious',
      },
      five: {
        index: 'v5',
        value: 'Eating trash outdoors',
        a_value: 'eating_trash_outdoors ',
      },
      six: {
        index: 'v6',
        value: 'Difficulties with create training',
        a_value: 'crate_training',
      },

    },
  },
  customV2_walking_issues: {
    options: {
      one: {
        index: 'v1',
        value: 'My dog doesnt walk out yet',
        a_value: 'dont_walk_yet',
      },
      two: {
        index: 'v2',
        value: 'Pulling on the leash',
        a_value: 'pulling_leash',
      },
      three: {
        index: 'v3',
        value: 'Eating trash from the streets',
        a_value: 'eating_trash',
      },
      four: {
        index: 'v4',
        value: 'Barking at other dogs',
        a_value: 'barking_at_dogs',
      },
      five: {
        index: 'v5',
        value: 'Barking at people',
        a_value: 'barking_at_people',
      },
    },
  },
  customV2_activity: {
    options: {
      one: {
        index: 'v1',
        value: 'Very active, cant sit still',
        a_value: 'very',
      },
      two: {
        index: 'v2',
        value: 'Moderately active, rests calmly after physical activity',
        a_value: 'moderately',
      },
      three: {
        index: 'v3',
        value: 'Low activity, lies down and sleeps a lot',
        a_value: 'low',
      },
    },
  },
  customV2_training_time: {
    options: {
      one: {
        index: 'v1',
        value: '10-15 minutes',
        a_value: '10-15m',
      },
      two: {
        index: 'v2',
        value: '15-20 minutes',
        a_value: '15-20m',
      },
      three: {
        index: 'v3',
        value: '20-30 minutes',
        a_value: '20-30m',
      },
      four: {
        index: 'v4',
        value: 'More than 30 minutes',
        a_value: 'more30m',
      },
    },
  },
  customV2_training: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, with the help of a professional dog trainer',
        a_value: 'yes_with_help',
      },
      two: {
        index: 'v2',
        value: 'Yes, on my own',
        a_value: 'yes_on_my_own',
      },
      three: {
        index: 'v3',
        value: 'Not yet, just planning to',
        a_value: 'not_yet',
      },
    },
  },
  customV2_command_1: {
    options: {
      one: {
        index: 'v1',
        value: 'Name',
        a_value: 'name',
      },
      two: {
        index: 'v2',
        value: 'Come',
        a_value: 'come',
      },
      three: {
        index: 'v3',
        value: 'No',
        a_value: 'no',
      },
      four: {
        index: 'v4',
        value: 'Food luring',
        a_value: 'food_luring',
      },
      five: {
        index: 'v5',
        value: 'High Five',
        a_value: 'high_five',
      },
      six: {
        index: 'v6',
        value: 'Touch',
        a_value: 'touch',
      },
      seven: {
        index: 'v7',
        value: 'Look',
        a_value: 'look',
      },
      eight: {
        index: 'v8',
        value: 'Stand',
        a_value: 'stand',
      },
      nine: {
        index: 'v9',
        value: 'Place',
        a_value: 'place',
      },
      ten: {
        index: 'v10',
        value: 'Off',
        a_value: 'off',
      },
      eleven: {
        index: 'v11',
        value: 'Drop it',
        a_value: 'drop_it',
      },
    },
  },
  customV2_command_2: {
    options: {
      one: {
        index: 'v1',
        value: 'Stand',
        a_value: 'stand',
      },
      two: {
        index: 'v2',
        value: 'Release cue',
        a_value: 'release_cue',
      },
      three: {
        index: 'v3',
        value: 'Drop it',
        a_value: 'drop_it',
      },
      four: {
        index: 'v4',
        value: 'Hug',
        a_value: 'hug',
      },
      five: {
        index: 'v5',
        value: 'Place',
        a_value: 'place',
      },
      six: {
        index: 'v6',
        value: 'Off',
        a_value: 'off',
      },
      seven: {
        index: 'v7',
        value: 'Spin',
        a_value: 'spin',
      },
      eight: {
        index: 'v8',
        value: 'Roll over',
        a_value: 'roll_over',
      },
      nine: {
        index: 'v9',
        value: 'Bunny',
        a_value: 'bunny',
      },
      ten: {
        index: 'v10',
        value: 'Hide',
        a_value: 'hide',
      },
      eleven: {
        index: 'v11',
        value: 'Bow',
        a_value: 'bow',
      },
    },
  },
  customV2_command_3: {
    options: {
      one: {
        index: 'v1',
        value: 'Come',
        a_value: 'come',
      },
      two: {
        index: 'v2',
        value: 'Catch a frisbe',
        a_value: 'catch_frisbe',
      },
      three: {
        index: 'v3',
        value: 'Jump through the arm circle',
        a_value: 'jump_arm_circle',
      },
      four: {
        index: 'v4',
        value: 'Wipe your paws',
        a_value: 'wipe_paws',
      },
      five: {
        index: 'v5',
        value: 'Dead',
        a_value: 'dead',
      },
      six: {
        index: 'v6',
        value: 'Walk between your legs',
        a_value: 'walk_between_legs',
      },
      seven: {
        index: 'v7',
        value: 'Snake',
        a_value: 'snake',
      },
      eight: {
        index: 'v8',
        value: 'Get my slippers',
        a_value: 'get_slippers',
      },
    },
  },
  customV2_command_4: {
    options: {
      one: {
        index: 'v1',
        value: 'Name',
        a_value: 'name',
      },
      two: {
        index: 'v2',
        value: 'No',
        a_value: 'no',
      },
      three: {
        index: 'v3',
        value: 'Come',
        a_value: 'come',
      },
      four: {
        index: 'v4',
        value: 'Food luring',
        a_value: 'food_luring',
      },
      five: {
        index: 'v5',
        value: 'Look',
        a_value: 'look',
      },
      six: {
        index: 'v6',
        value: 'Drop it',
        a_value: 'drop_it',
      },
      seven: {
        index: 'v7',
        value: 'Off',
        a_value: 'off',
      },
      eight: {
        index: 'v8',
        value: 'Stand',
        a_value: 'stand',
      },
      nine: {
        index: 'v9',
        value: 'Hug',
        a_value: 'hug',
      },
    },
  },
  customV2_info_breed: {

  },
  customV2_info_breed_2: {

  },
  customV2_info_breed_3: {

  },
  customV2_creating_program: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, I love it!',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'Sometimes, when were both in the mood',
        a_value: 'sometimes',
      },
      three: {
        index: 'v3',
        value: 'Not as much as I like to',
        a_value: 'not_as_much',
      },
      four: {
        index: 'v4',
        value: 'Honestly, it can be a challenge',
        a_value: 'it_is_challenge',
      },
    },
  },
  customV2_plan: {},
  customV2_info_predict: {},
  customV3_gender: {
    options: {
      v1: {
        index: 'v1',
        value: 'Girl',
        a_value: 'girl',
      },
      v2: {
        index: 'v2',
        value: 'Boy',
        a_value: 'boy',
      },
    },
  },
  customV4_behavior_problem: {
    options: {
      v1: {
        index: 'v1',
        value: 'Potty issues',
        a_value: 'potty_issues',
      },
      v2: {
        index: 'v2',
        value: 'Chewing',
        a_value: 'chewing',
      },
      v3: {
        index: 'v3',
        value: 'Biting or barking',
        a_value: 'biting_or_barking',
      },
      v4: {
        index: 'v4',
        value: 'Pulling the leash',
        a_value: 'pulling_the_leash',
      },
    },
  },
  customV5_behavior_problem: {
    options: {
      v1: {
        index: 'v1',
        value: 'potty_issues',
        a_value: 'potty_issues',
      },
      v2: {
        index: 'v2',
        value: 'chewing',
        a_value: 'chewing',
      },
      v3: {
        index: 'v3',
        value: 'biting',
        a_value: 'biting',
      },
      v4: {
        index: 'v4',
        value: 'crate_training',
        a_value: 'crate_training',
      },
      v5: {
        index: 'v5',
        value: 'pulling_leash',
        a_value: 'pulling_leash',
      },
      v6: {
        index: 'v6',
        value: 'barking',
        a_value: 'barking',
      },
      v7: {
        index: 'v7',
        value: 'jumping_up',
        a_value: 'jumping_up',
      },
    },
  },
  customV2_age_v2: {
    options: {
      one: {
        index: 'v1',
        value: '0-2 months',
        a_value: '0-2m',
      },
      two: {
        index: 'v2',
        value: '2-6 months',
        a_value: '2-6m',
      },
      three: {
        index: 'v3',
        value: '6-11 months',
        a_value: '6-11m',
      },
      four: {
        index: 'v4',
        value: '1-2 years',
        a_value: '1-2y',
      },
      five: {
        index: 'v5',
        value: '2-7 years',
        a_value: '2-7y',
      },
      six: {
        index: 'v6',
        value: '7+ years',
        a_value: 'more7y',
      },
    },
  },
  customV2_age_v3: {
    options: {
      one: {
        index: 'v1',
        value: 'puppy',
        a_value: 'puppy',
      },
      two: {
        index: 'v2',
        value: 'adult',
        a_value: 'adult',
      },
    },
  },
  customV2_age_v4: {
    options: {
      one: {
        index: 'v1',
        value: 'puppy',
        a_value: 'puppy',
      },
      two: {
        index: 'v2',
        value: 'adult',
        a_value: 'adult',
      },
    },
  },
  customV2_age_v5: {
    options: {
      one: {
        index: 'v1',
        value: 'puppy',
        a_value: 'puppy',
      },
      two: {
        index: 'v2',
        value: 'adult',
        a_value: 'adult',
      },
    },
  },
  customV2_reason: {
    options: {
      one: {
        index: 'v1',
        value: 'Adopting a new dog',
        a_value: 'adopting_new_dog',
      },
      two: {
        index: 'v2',
        value: 'Bringing home a baby',
        a_value: 'baby',
      },
      three: {
        index: 'v3',
        value: 'Moving to a new home',
        a_value: 'moving_new_home',
      },
      four: {
        index: 'v4',
        value: 'Getting married/moving In',
        a_value: 'getting_married',
      },
      five: {
        index: 'v5',
        value: 'Schedule change at work',
        a_value: 'schedule_change',
      },
      six: {
        index: 'v6',
        value: 'Travel plans',
        a_value: 'travel_plans',
      },
      seven: {
        index: 'v7',
        value: 'Hosting guests',
        a_value: 'hosting_guests',
      },
      eight: {
        index: 'v8',
        value: 'No, just want to get a well-behaved pet!',
        a_value: 'well_behaved_pet',
      },
    },
  },
  customV2_date: {

  },
  customV2_food: {
    options: {
      one: {
        index: 'v1',
        value: 'Natural or raw food',
        a_value: 'natural',
      },
      two: {
        index: 'v2',
        value: 'Dry food',
        a_value: 'dry',
      },
      three: {
        index: 'v3',
        value: 'Dry food and canned food',
        a_value: 'dry_canned',
      },
      four: {
        index: 'v4',
        value: 'Special dietary food',
        a_value: 'special_dietary',
      },
    },
  },
  issues_biting: {
    options: {
      one: {
        index: 'v1',
        value: 'Dog bites, shows aggression',
        a_value: 'aggression',
      },
      two: {
        index: 'v2',
        value: 'Occasionally bites during play',
        a_value: 'occasionally',
      },
      three: {
        index: 'v3',
        value: 'Almost never bites',
        a_value: 'almost_never',
      },
      four: {
        index: 'v4',
        value: 'No issues with biting',
        a_value: 'no_issues',
      },
    },
  },
  issues_damage: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, chews on everything',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'Chews on things, when left alone',
        a_value: 'when_alone',
      },
      three: {
        index: 'v3',
        value: 'Very rarely chews on anything',
        a_value: 'rarely',
      },
      four: {
        index: 'v4',
        value: 'Doesn’t damage',
        a_value: 'no',
      },
    },
  },
  issues_crate: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, my dog is crate-trained',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'Сrate training is in progress',
        a_value: 'in_progress',
      },
      three: {
        index: 'v3',
        value: 'No, but I’d like to try',
        a_value: 'no',
      },
      four: {
        index: 'v4',
        value: 'I’m not interested in crate training',
        a_value: 'not_interesting',
      },
    },
  },
  issues_home: {
    options: {
      one: {
        index: 'v1',
        value: 'Always very anxious, whines, and may damage things',
        a_value: 'anxious',
      },
      two: {
        index: 'v2',
        value: 'Usually well-behaved, but occasionally shows anxiety',
        a_value: 'occasionally_anxiety',
      },
      three: {
        index: 'v3',
        value: 'Remains calm',
        a_value: 'remains_calm',
      },
      four: {
        index: 'v4',
        value: 'I don’t leave my dog alone at home',
        a_value: 'not_leave_alone',
      },
    },
  },
  follow_commands: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, always',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'Mostly yes, but sometimes ignores me',
        a_value: 'mostly_yes',
      },
      three: {
        index: 'v3',
        value: 'Very rarely',
        a_value: 'very_rarely',
      },
      four: {
        index: 'v4',
        value: 'Never',
        a_value: 'never',
      },
    },
  },
  get_irritated: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, I get very irritated',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'Sometimes, but I’m usually calm',
        a_value: 'sometimes',
      },
      three: {
        index: 'v3',
        value: 'Never, my dog can’t upset me',
        a_value: 'never',
      },
    },
  },
  raise_voice: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, I often yell at my dog',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'Sometimes, but not regularly',
        a_value: 'sometimes',
      },
      three: {
        index: 'v3',
        value: 'It’s happened a few times',
        a_value: 'few_times',
      },
      four: {
        index: 'v4',
        value: 'No, never',
        a_value: 'never',
      },
    },
  },
  hit_dog: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, I often physically discipline my dog',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'It’s happened a few times',
        a_value: 'few_times',
      },
      three: {
        index: 'v3',
        value: 'No, never',
        a_value: 'never',
      },
    },
  },
  how_attached: {
    options: {
      one: {
        index: 'v1',
        value: 'Very attached, follows me everywhere, dislikes being alone',
        a_value: 'very_attached',
      },
      two: {
        index: 'v2',
        value: 'Attached, is happy to see me but stays alone comfortably',
        a_value: 'attached',
      },
      three: {
        index: 'v3',
        value: 'Doesn’t seem attached, shows little interest in me',
        a_value: 'not_attached',
      },
    },
  },
  info_thank: {

  },
  customV2_potty_v2: {
    options: {
      one: {
        index: 'v1',
        value: 'Pottying  without a stable schedule',
        a_value: 'without_schedule',
      },
      two: {
        index: 'v2',
        value: 'Potty accidents during the night',
        a_value: 'during_the_night',
      },
      three: {
        index: 'v3',
        value: 'Potty accidents when left alone at home',
        a_value: 'alone_at_home',
      },
      four: {
        index: 'v4',
        value: 'Accidents because of marking behavior (territorial urination)',
        a_value: 'territorial_urination',
      },
      five: {
        index: 'v5',
        value: 'Accidents because of stress or fear (e.g., from loud noises)',
        a_value: 'stress',
      },
      six: {
        index: 'v6',
        value: 'My dog is potty trained!',
        a_value: 'potty_trained',
      },
    },
  },
  potty_how_long: {
    options: {
      one: {
        index: 'v1',
        value: 'Since I got the dog',
        a_value: 'since_i_got',
      },
      two: {
        index: 'v2',
        value: 'For a few weeks',
        a_value: 'few_weeks',
      },
      three: {
        index: 'v3',
        value: 'For more than a month',
        a_value: 'more_month',
      },
      four: {
        index: 'v4',
        value: 'Recently started',
        a_value: 'recently_started',
      },
    },
  },
  potty_where: {
    options: {
      one: {
        index: 'v1',
        value: 'Indoors, in the same spot',
        a_value: 'indoors_same_spot',
      },
      two: {
        index: 'v2',
        value: 'Indoors, in different spots',
        a_value: 'indoors_different_spots',
      },
      three: {
        index: 'v3',
        value: 'Outdoors, in inappropriate places',
        a_value: 'outdoors',
      },
      four: {
        index: 'v4',
        value: 'Both indoors and outdoors',
        a_value: 'both',
      },
    },
  },
  potty_how_often_walks: {
    options: {
      one: {
        index: 'v1',
        value: 'My dog doesn`t walk out yet',
        a_value: 'not_walk_yet',
      },
      two: {
        index: 'v2',
        value: 'Less than 2 times a day',
        a_value: 'less2t',
      },
      three: {
        index: 'v3',
        value: '2 times a day',
        a_value: '2t',
      },
      four: {
        index: 'v4',
        value: '3 or more times a day',
        a_value: 'more2t',
      },
      five: {
        index: 'v5',
        value: 'It varies (no fixed schedule)',
        a_value: 'it_varies',
      },
    },
  },
  potty_health_issues: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, known issues (e.g., bladder problems)',
        a_value: 'yes_known_issues',
      },
      two: {
        index: 'v2',
        value: 'Yes, but unsure if they’re related',
        a_value: 'yes_not_related',
      },
      three: {
        index: 'v3',
        value: 'My dog is healthy',
        a_value: 'healthy',
      },
      four: {
        index: 'v4',
        value: 'I don’t know',
        a_value: 'dont_known',
      },
    },
  },
  potty_where_want: {
    options: {
      one: {
        index: 'v1',
        value: 'Indoors on pee pads or litter box',
        a_value: 'indoors_pee_pads',
      },
      two: {
        index: 'v2',
        value: 'Outdoors in a designated area',
        a_value: 'outdoors_designated_area',
      },
      three: {
        index: 'v3',
        value: 'Both indoors and outdoors',
        a_value: 'both',
      },
      four: {
        index: 'v4',
        value: 'Not sure yet',
        a_value: 'not_sure_yet',
      },
    },
  },
  info_about_potty: {

  },
  training_raise_voice: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, I raise my voice significantly',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'I give the dog a verbal correction without showing aggression',
        a_value: 'verbal_connection',
      },
      three: {
        index: 'v3',
        value: 'I rarely react to it',
        a_value: 'rarely',
      },
      four: {
        index: 'v4',
        value: 'I never react',
        a_value: 'never',
      },
    },
  },
  training_react_to_punishment: {
    options: {
      one: {
        index: 'v1',
        value: 'Gets scared and hides',
        a_value: 'scared',
      },
      two: {
        index: 'v2',
        value: 'Acts normally',
        a_value: 'normally',
      },
      three: {
        index: 'v3',
        value: 'Becomes more anxious',
        a_value: 'anxious',
      },
      four: {
        index: 'v4',
        value: 'I don’t punish my dog',
        a_value: 'not_punish_dog',
      },
    },
  },
  owner_feelings: {
    options: {
      one: {
        index: 'v1',
        value: 'Overjoyed and excited!',
        a_value: 'overjoyed',
      },
      two: {
        index: 'v2',
        value: 'A mix of happy and stressed',
        a_value: 'happy_stressed',
      },
      three: {
        index: 'v3',
        value: 'Overwhelmed and unsure if I made the right decision',
        a_value: 'overwhelmed',
      },
      four: {
        index: 'v4',
        value: 'Regretful or very stressed most of the time',
        a_value: 'regretful',
      },
    },
  },
  owner_sleep: {
    options: {
      one: {
        index: 'v1',
        value: 'The same as before – my puppy sleeps well',
        a_value: 'same_as_before',
      },
      two: {
        index: 'v2',
        value: 'A bit less, but it’s manageable',
        a_value: 'a_bit_less',
      },
      three: {
        index: 'v3',
        value: 'Significantly less; I feel sleep-deprived',
        a_value: 'significantly_less',
      },
      four: {
        index: 'v4',
        value: 'I barely sleep at all',
        a_value: 'dont_sleep',
      },
    },
  },
  owner_puppy_behavior: {
    options: {
      one: {
        index: 'v1',
        value: 'My puppy is generally well-behaved',
        a_value: 'well_behaved',
      },
      two: {
        index: 'v2',
        value: 'Occasionally challenging, but nothing I can’t handle',
        a_value: 'occasionally_challenging',
      },
      three: {
        index: 'v3',
        value: 'Frequently challenging – it’s hard to keep up',
        a_value: 'frequently_challenging',
      },
      four: {
        index: 'v4',
        value: 'Extremely challenging – I feel like I’m losing control',
        a_value: 'extremely_challenging',
      },
    },
  },
  owner_puppy_managing: {
    options: {
      one: {
        index: 'v1',
        value: 'Very confident – I know what I’m doing',
        a_value: 'very_confident',
      },
      two: {
        index: 'v2',
        value: 'Moderately confident – I have some idea, but I need help',
        a_value: 'moderately_confident',
      },
      three: {
        index: 'v3',
        value: 'Not very confident – I feel unsure about many things',
        a_value: 'not_very_confident',
      },
      four: {
        index: 'v4',
        value: 'Not confident at all – I don’t know where to start',
        a_value: 'not_confident',
      },
    },
  },
  owner_puppy_affect: {
    options: {
      one: {
        index: 'v1',
        value: 'It’s easy to balance my daily activities with dog care',
        a_value: 'balance',
      },
      two: {
        index: 'v2',
        value: 'Some adjustments were needed, but it’s manageable',
        a_value: 'manageable',
      },
      three: {
        index: 'v3',
        value: 'I’ve had to make major changes to my routine, and it’s difficult',
        a_value: 'difficult',
      },
      four: {
        index: 'v4',
        value: 'My routine feels completely disrupted',
        a_value: 'disrupted',
      },
    },
  },
  owner_support: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, I receive support from close ones or experts',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'Somewhat, but I could use more support',
        a_value: 'somewhat',
      },
      three: {
        index: 'v3',
        value: 'Not much – I feel like I’m handling this alone',
        a_value: 'not_much',
      },
      four: {
        index: 'v4',
        value: 'Not at all – I feel completely isolated',
        a_value: 'not_at_all',
      },
    },
  },
  owner_concerns: {
    options: {
      one: {
        index: 'v1',
        value: 'Training and obedience issues',
        a_value: 'training',
      },
      two: {
        index: 'v2',
        value: 'Potty training challenges',
        a_value: 'potty_training',
      },
      three: {
        index: 'v3',
        value: 'My puppy’s health or behavior',
        a_value: 'health',
      },
      four: {
        index: 'v4',
        value: 'Balancing puppy care with my personal responsibilities',
        a_value: 'balance',
      },
      five: {
        index: 'v5',
        value: 'Feeling unsure about my decision to get a dog',
        a_value: 'unsureness',
      },
    },
  },
  info_about_owner: {

  },
  statement_irritation: {
    options: {
      one: {
        index: 'v1',
        value: 'not_at_all',
        a_value: 'not_at_all',
      },
      two: {
        index: 'v2',
        value: 'not_much',
        a_value: 'not_much',
      },
      three: {
        index: 'v3',
        value: 'somewhat',
        a_value: 'somewhat',
      },
      four: {
        index: 'v4',
        value: 'yes',
        a_value: 'yes',
      },
      five: {
        index: 'v5',
        value: 'totally',
        a_value: 'totally',
      },
    },
  },
  statement_ignore_commands: {
    options: {
      one: {
        index: 'v1',
        value: 'not_at_all',
        a_value: 'not_at_all',
      },
      two: {
        index: 'v2',
        value: 'not_much',
        a_value: 'not_much',
      },
      three: {
        index: 'v3',
        value: 'somewhat',
        a_value: 'somewhat',
      },
      four: {
        index: 'v4',
        value: 'yes',
        a_value: 'yes',
      },
      five: {
        index: 'v5',
        value: 'totally',
        a_value: 'totally',
      },
    },
  },
  statement_strong_bond: {
    options: {
      one: {
        index: 'v1',
        value: 'not_at_all',
        a_value: 'not_at_all',
      },
      two: {
        index: 'v2',
        value: 'not_much',
        a_value: 'not_much',
      },
      three: {
        index: 'v3',
        value: 'somewhat',
        a_value: 'somewhat',
      },
      four: {
        index: 'v4',
        value: 'yes',
        a_value: 'yes',
      },
      five: {
        index: 'v5',
        value: 'totally',
        a_value: 'totally',
      },
    },
  },
  customV2_startPageGender: {
    options: {
      v1: {
        index: 'v1',
        value: 'Girl',
        a_value: 'girl',
      },
      v2: {
        index: 'v2',
        value: 'Boy',
        a_value: 'boy',
      },
    },
  },
  customV2_quote: {

  },
  main_goal: {
    options: {
      one: {
        index: 'v1',
        value: 'puppy_basics',
        a_value: 'puppy_basics',
      },
      two: {
        index: 'v2',
        value: 'improve_obedience',
        a_value: 'improve_obedience',
      },
      three: {
        index: 'v3',
        value: 'overcome_reactivity',
        a_value: 'overcome_reactivity',
      },
      four: {
        index: 'v4',
        value: 'decrease_aggression',
        a_value: 'decrease_aggression',
      },
      five: {
        index: 'v5',
        value: 'stronger_bond',
        a_value: 'stronger_bond',
      },
    },
  },
  gender_zw: {
    options: {
      v1: {
        index: 'v1',
        value: 'Girl',
        a_value: 'girl',
      },
      v2: {
        index: 'v2',
        value: 'Boy',
        a_value: 'boy',
      },
    },
  },
  zw_age: {
    options: {
      one: {
        index: 'v1',
        value: '0-6 months',
        a_value: '0-6m',
      },
      two: {
        index: 'v2',
        value: '7-12 months',
        a_value: '7-12m',
      },
      three: {
        index: 'v3',
        value: '1-2 years',
        a_value: '1-2y',
      },
      four: {
        index: 'v4',
        value: '2-7 years',
        a_value: '2-7y',
      },
      five: {
        index: 'v5',
        value: 'More than 7 years',
        a_value: 'more7y',
      },
    },
  },
  start_page_age: {
    options: {
      one: {
        index: 'v1',
        value: '0-6 months',
        a_value: '0-6m',
      },
      two: {
        index: 'v2',
        value: '7-12 months',
        a_value: '7-12m',
      },
      three: {
        index: 'v3',
        value: '1-5 years',
        a_value: '1-5y',
      },
      four: {
        index: 'v4',
        value: '5+ years',
        a_value: 'more5y',
      },
    },
  },
  start_page_age_v2: {
    options: {
      one: {
        index: 'v1',
        value: '0-6 months',
        a_value: '0-6m',
      },
      two: {
        index: 'v2',
        value: '7-12 months',
        a_value: '7-12m',
      },
      three: {
        index: 'v3',
        value: '1-5 years',
        a_value: '1-5y',
      },
      four: {
        index: 'v4',
        value: '5+ years',
        a_value: 'more5y',
      },
    },
  },
  start_page_age_v3: {
    options: {
      one: {
        index: 'v1',
        value: '0-6 months',
        a_value: '0-6m',
      },
      two: {
        index: 'v2',
        value: '7-12 months',
        a_value: '7-12m',
      },
      three: {
        index: 'v3',
        value: '1-5 years',
        a_value: '1-5y',
      },
      four: {
        index: 'v4',
        value: '5+ years',
        a_value: 'more5y',
      },
    },
  },
  training_time: {
    options: {
      one: {
        index: 'v1',
        value: 'little_every_day',
        a_value: 'little_every_day',
      },
      two: {
        index: 'v2',
        value: '3_4_times_week',
        a_value: '3_4_times_week',
      },
      three: {
        index: 'v3',
        value: '1_2_times_week',
        a_value: '1_2_times_week',
      },
      four: {
        index: 'v4',
        value: 'not_sure_yet',
        a_value: 'not_sure_yet',
      },
    },
  },
  crate_trained: {
    options: {
      one: {
        index: 'v1',
        value: 'yes',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'somewhat',
        a_value: 'somewhat',
      },
      three: {
        index: 'v3',
        value: 'not_yet',
        a_value: 'not_yet',
      },
      four: {
        index: 'v4',
        value: 'dont_use_crate',
        a_value: 'dont_use_crate',
      },
    },
  },
  info_about_crate: {

  },
  accidents_how_often: {
    options: {
      one: {
        index: 'v1',
        value: 'Several times a day',
        a_value: 'several_times_day',
      },
      two: {
        index: 'v2',
        value: 'Once a day',
        a_value: 'once_day',
      },
      three: {
        index: 'v3',
        value: 'A few times a week',
        a_value: 'few_times_week',
      },
      four: {
        index: 'v4',
        value: 'Rarely or never',
        a_value: 'rarely_never',
      },
    },
  },
  accidents_what_do: {
    options: {
      one: {
        index: 'v1',
        value: 'Clean it up silently',
        a_value: 'clean_it',
      },
      two: {
        index: 'v2',
        value: 'Scold or say “no”',
        a_value: 'scold',
      },
      three: {
        index: 'v3',
        value: 'Try to interrupt and take them outside',
        a_value: 'interrupt',
      },
      four: {
        index: 'v4',
        value: 'I’m not sure what to do',
        a_value: 'not_sure_what_to_do',
      },
    },
  },
  concern_toilet_training: {
    options: {
      one: {
        index: 'v1',
        value: 'Accidents won’t stop',
        a_value: 'wont_stop',
      },
      two: {
        index: 'v2',
        value: 'I don’t understand my puppy’s signals',
        a_value: 'dont_understand_signals',
      },
      three: {
        index: 'v3',
        value: 'I’m afraid I’m doing something wrong',
        a_value: 'doing_something_wrong',
      },
      four: {
        index: 'v4',
        value: 'I don’t know how to build a consistent routine',
        a_value: 'how_to_build_routine',
      },
    },
  },
  info_about_potty_struggles: {

  },
  puppy_issues_at_home: {
    options: {
      one: {
        index: 'v1',
        value: 'Biting',
        a_value: 'biting',
      },
      two: {
        index: 'v2',
        value: 'Barking',
        a_value: 'barking',
      },
      three: {
        index: 'v3',
        value: 'Chewing or damaging furniture',
        a_value: 'chewing_damaging',
      },
      four: {
        index: 'v4',
        value: 'Very anxious and sad when left alone',
        a_value: 'anxious',
      },
    },
  },
  puppy_chew: {
    options: {
      one: {
        index: 'v1',
        value: 'Furniture',
        a_value: 'furniture',
      },
      two: {
        index: 'v2',
        value: 'Shoes',
        a_value: 'shoes',
      },
      three: {
        index: 'v3',
        value: 'Cables or cords',
        a_value: 'cables_cords',
      },
      four: {
        index: 'v4',
        value: 'Walls or baseboards',
        a_value: 'walls_baseboards',
      },
      five: {
        index: 'v5',
        value: 'Only toys',
        a_value: 'only_toys',
      },
    },
  },
  puppy_bite_hands: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, constantly',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'Sometimes',
        a_value: 'sometimes',
      },
      three: {
        index: 'v3',
        value: 'Rarely',
        a_value: 'rarely',
      },
      four: {
        index: 'v4',
        value: 'Never',
        a_value: 'never',
      },
    },
  },
  puppy_leave_house: {
    options: {
      one: {
        index: 'v1',
        value: 'Whines or barks a lot',
        a_value: 'whines_barks',
      },
      two: {
        index: 'v2',
        value: 'Chews or destroys things',
        a_value: 'chews_destroys_things',
      },
      three: {
        index: 'v3',
        value: 'Seems calm, but only for a short time',
        a_value: 'seems_calm',
      },
      four: {
        index: 'v4',
        value: 'I haven’t tried leaving yet',
        a_value: 'not_leaving_yet',
      },
    },
  },
  fix_behavior_issues: {
    options: {
      one: {
        index: 'v1',
        value: 'YouTube videos',
        a_value: 'youtube',
      },
      two: {
        index: 'v2',
        value: 'Advice from friends or family',
        a_value: 'advices',
      },
      three: {
        index: 'v3',
        value: 'Random tips without a system',
        a_value: 'random_tips',
      },
      four: {
        index: 'v4',
        value: 'Working with a trainer',
        a_value: 'trainer',
      },
      five: {
        index: 'v5',
        value: 'Nothing yet',
        a_value: 'nothing_yet',
      },
    },
  },
  info_about_training: {},
  puppy_commands: {
    options: {
      one: {
        index: 'v1',
        value: 'Name',
        a_value: 'name',
      },
      two: {
        index: 'v2',
        value: 'Come',
        a_value: 'come',
      },
      three: {
        index: 'v3',
        value: 'No',
        a_value: 'no',
      },
      four: {
        index: 'v4',
        value: 'Food luring',
        a_value: 'food_luring',
      },
      five: {
        index: 'v5',
        value: 'High Five',
        a_value: 'high_five',
      },
      six: {
        index: 'v6',
        value: 'Touch',
        a_value: 'touch',
      },
      seven: {
        index: 'v7',
        value: 'Look',
        a_value: 'look',
      },
      eight: {
        index: 'v8',
        value: 'Stand',
        a_value: 'stand',
      },
      nine: {
        index: 'v9',
        value: 'Place',
        a_value: 'place',
      },
      ten: {
        index: 'v10',
        value: 'Off',
        a_value: 'off',
      },
      eleven: {
        index: 'v11',
        value: 'Drop it',
        a_value: 'drop_it',
      },
    },
  },
  first_puppy: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes',
        a_value: 'yes',
      },
      two: {
        index: 'v2',
        value: 'No, I’ve had dogs before',
        a_value: 'no',
      },
    },
  },
  age_group: {
    options: {
      one: {
        index: 'v1',
        value: '18 - 24 years',
        a_value: '18-24',
      },
      two: {
        index: 'v2',
        value: '25 - 34 years',
        a_value: '25-34',
      },
      three: {
        index: 'v3',
        value: '35 - 44 years',
        a_value: '35-44',
      },
      four: {
        index: 'v4',
        value: '45 - 54 years',
        a_value: '45-54',
      },
      five: {
        index: 'v5',
        value: '55+ years',
        a_value: '55+',
      },
    },
  },
  understanding: {
    options: {
      one: {
        index: 'v1',
        value: 'All the time',
        a_value: 'all_the_time',
      },
      two: {
        index: 'v2',
        value: 'Sometimes',
        a_value: 'sometimes',
      },
      three: {
        index: 'v3',
        value: 'Only in specific situations',
        a_value: 'specific_situations',
      },
      four: {
        index: 'v4',
        value: 'Not really',
        a_value: 'not_really',
      },
    },
  },
  info_about_understanding: {
    
  },
  understanding_when: {
    options: {
      one: {
        index: 'v1',
        value: 'When barking or whining',
        a_value: 'barking_whining',
      },
      two: {
        index: 'v2',
        value: 'When feeling anxious or restless',
        a_value: 'anxious_restless',
      },
      three: {
        index: 'v3',
        value: 'When bringing toys or staring at you',
        a_value: 'bringing_toys',
      },
      four: {
        index: 'v4',
        value: 'Not reallyWhen making unusual sounds',
        a_value: 'unusual_sounds',
      },
    },
  },
  understanding_real_time: {
    options: {
      one: {
        index: 'v1',
        value: 'Yes, that would be amazing',
        a_value: 'yes_amazing',
      },
      two: {
        index: 'v2',
        value: 'Yes, especially during barking',
        a_value: 'yes_barking',
      },
      three: {
        index: 'v3',
        value: 'Maybe, sounds interesting',
        a_value: 'maybe',
      },
      four: {
        index: 'v4',
        value: 'Not really',
        a_value: 'not_really',
      },
    },
  },
  understanding_summary: {

  },
};
